(function ($) {
    $.widget('femcare.singleFieldDate', {
        options: {},

        _onSelect: function () {
            this.$input.validate();
        }
    });

}(jQuery));